<!--
  File name: PBNEFLanding.vue
  Program Description:
    - This component renders the landing page for PBNEF
    - This shows the list of existing submitted PBNEF
    - A way to view all PBNEF submitted as draft

  Includes:
    - PBNEFBreadCrumbs
    - PBNEFList
-->
<template>
  <v-container>
    <PBNEFBreadCrumbs />
    <v-row
      align-self="start"
      justify="center"
    >
      <v-col class="mb-0 pb-0">
        <v-card
          tile
          elevation="0"
          outlined
        >
          <v-card-title class="pt-2 pb-2">
            <!-- For all user role -->
            <v-btn
              id="back-btn"
              color="grey darken-1"
              text
              :loading="loading"
              @click="$router.push({
                name: 'DataBreachView',
                params: {
                  dataTab,
                  operation: 'view',
                  id: dbn
                }
              })"
            >
              <v-icon>mdi-arrow-left-thin</v-icon> Back to {{ dbnNumber }}
            </v-btn>
            <v-spacer />
            <template v-if="isPdbnfValid">
              <!-- For evaluator -->
              <v-btn
                v-if="showLabel('canViewAllPbnef') && isEvaluator"
                id="drafts-btn"
                text
                color="primary"
                :loading="loading"
                @click="goToDrafts()"
              >
                {{ getLabel('canViewAllPbnef', `Drafts (${ numberOfDrafts })`) }}
              </v-btn>
              <!-- For evaluator -->
              <v-btn
                v-if="showLabel('canPostPbnef') && typeOfRequests.length && isEvaluator && isAssignee"
                id="initiate-btn"
                color="primary"
                type="button"
                :loading="loading"
                @click="$router.push({
                  name: 'PBNEFCreate',
                  params: {
                    operation: 'create'
                  }
                })"
              >
                <v-icon
                  small
                  class="mr-2"
                >
                  mdi-file-plus
                </v-icon>
                {{ getLabel(`canPostPbnef`, `Initiate PBNEF (${typeOfRequests.length})`) }}
              </v-btn>
            </template>
          </v-card-title>
        </v-card>
      </v-col>
    </v-row>
    <v-row
      align-self="start"
      justify="center"
    >
      <v-col class="mt-0 pt-0">
        <v-card
          tile
          elevation="0"
          outlined
        >
          <v-card-text class="pt-0">
            <v-container>
              <v-row>
                <v-col class="px-6 py-4">
                  <h1 class="title primary--text">
                    Preliminary Breach Notification Evaluation Form
                  </h1>
                </v-col>
              </v-row>
              <v-container>
                <PBNEFList v-if="dbnNumber" />
              </v-container>
            </v-container>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { privilegeMixin } from 'session-plugin'
import pbnefMixin from '@/mixins/pbnefMixin'
import { mapFields } from 'vuex-map-fields'
import crud from '@/utils/rest/crud'

import PBNEFList from './PBNEFList.vue'
import PBNEFBreadCrumbs from './PBNEFBreadCrumbs.vue'

export default {
  name: 'PBNEF',
  components: {
    PBNEFList,
    PBNEFBreadCrumbs
  },
  mixins: [
    privilegeMixin,
    pbnefMixin
  ],
  data: () => ({
    loading: false
  }),
  computed: {
    ...mapFields('pbnef', {
      $meta: '$meta',
      isSubmitted: 'isSubmitted',
      typeOfRequests: 'typeOfRequests',
      numberOfDrafts: 'numberOfDrafts'
    }),
    dataTab () {
      return this.$route.params.dataTab
    }
  },
  async mounted () {
    this.$store.dispatch('pbnef/set', {
      isSubmitted: true
    })
    this.loading = true
    await this.fetchDrafts()
    this.loading = false
  },
  methods: {
    goToDrafts () {
      this.$store.dispatch('pbnef/set', {
        isSubmitted: false
      })
      this.$router.push({
        name: 'PBNEFDrafts'
      })
    },
    async fetchDrafts () {
      const response = await crud('dbnStatus').list({ count: 10000 })
      const statuses = response.entries
      const draft = statuses.find(x => x.value === 'Drafted')
      const advancedQuery = {
        $and: [
          { status: draft._id },
          { docketNumber: this.dbnNumber }
        ]
      }
      const dataview = 'table'
      const list = await crud('pbnef').list({ advancedQuery, dataview })
      if (list.ok) this.$set(this, 'numberOfDrafts', list.entries.length)
    }
  }
}
</script>

<style scoped>
.transparent-bg {
  background-color: rgba(0,0,0,0);
}

.v-btn {
  text-transform: none;
}
</style>
